import { Button, Space } from "antd";
import { useEffect } from "react";
import CVPdfIcon from "../../assets/icons/CVPdfIcon";
import { useInterviewBulkOfferStatusMutation } from "../../features/employee/employeeApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { toast } from "../../lib/toast";
import { CustomModalProps, TInterview } from "../../types";
import ConfirmModal from "../ui/ConfirmModal";
import CustomModal from "../ui/CustomModal";
import SendOfferLetterModal from "./SendOfferLetterModal";

type Status = TInterview["offer_status"];
type Props = {
  details: string;
  cv: string;
  id: number;
  status: TInterview["status"];
  offerStatus: TInterview["offer_status"];
  email?: string;
  phone?: string;
} & CustomModalProps;

export default function InterviewDetails({
  handleClose,
  details,
  cv,
  id,
  status,
  offerStatus,
  email,
  phone,
  ...rest
}: Props) {
  const {
    open,
    handleOpen,
    handleClose: handleModalClose,
  } = useModal<Status | undefined>();
  const [interviewBulkOfferStatus, { isLoading, isError, error, isSuccess }] =
    useInterviewBulkOfferStatusMutation();
  useError(
    isError,
    error,
    open?.data === "rejected"
      ? "Application reject fail"
      : "Application short fail"
  );

  const handleApproveOrReject = (status: Status) => {
    const newValues = {
      interview_ids: [id],
      offer_status: status,
    };

    interviewBulkOfferStatus(newValues);
  };

  useEffect(() => {
    if (isSuccess) {
      toast(
        "success",
        open?.data === "rejected"
          ? "Application rejected successfully"
          : "Offer letter sent successfully"
      );
      handleClose && handleClose(true);
      handleModalClose(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, open?.data]);

  return (
    <CustomModal
      width={800}
      className={`confirm-modal footer-end`}
      handleClose={handleClose}
      footer={null}
      {...rest}
    >
      {open?.type === "UPDATE" && (
        <ConfirmModal
          open={open?.open}
          handleClose={handleModalClose}
          handleOk={() =>
            open?.data && handleApproveOrReject(open?.data as Status)
          }
          confirmTitle="Are you sure?"
          questionText={
            open?.data === "offered"
              ? "Do you want to offer this applicant a offer letter?"
              : "Do you wish to reject this candidate?"
          }
          okText="Confirm"
          okLoading={isLoading}
        />
      )}
      {open?.type === "ADD" && (
        <SendOfferLetterModal
          id={id}
          status="offered"
          open={open?.open}
          onClose={() => {
            handleModalClose();
            handleClose && handleClose();
          }}
        />
      )}
      <div className="space-y-2 text-sm text-gray-700 mb-2">
        <div className="flex">
          <span className="w-20 font-semibold">Email:</span>
          <span className="break-words">{email}</span>
        </div>
        <div className="flex">
          <span className="w-20 font-semibold">Mobile:</span>
          <span className="break-words">{phone}</span>
        </div>
      </div>
      <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
        {details}
      </pre>
      <div className="py-6">
        <a
          href={cv}
          target="_blank"
          download
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded-md bg-[#FFF9DF]"
        >
          <CVPdfIcon color="#B18A00" />
          <span className="text-[#B18A00] text-sm font-medium">
            View CV/Resume
          </span>
        </a>
      </div>
      <Space className="w-full mt-2" size={12}>
        {/* <Button
          className="normal-dark-button modal-button"
          onClick={handleClose}
          size="middle"
        >
          Cancel
        </Button> */}
        {status === "completed" && !offerStatus ? (
          <>
            <Button
              type="primary"
              className="!text-[#FF3838] disabled:!text-[#FF3838]/70 disabled:!bg-[#FFF5F4] !bg-[#FFF5F4] !border-[##FFF5F4] modal-button"
              onClick={() => handleOpen({ data: "rejected", type: "UPDATE" })}
              disabled={isLoading}
            >
              Reject
            </Button>
            <Button
              type="primary"
              onClick={() => handleOpen({ data: "offered", type: "ADD" })}
              disabled={isLoading}
              className="modal-button"
            >
              Send Offer Letter
            </Button>
          </>
        ) : null}
      </Space>
    </CustomModal>
  );
}
